module.exports = __webpack_public_path__ + "nback-arrow.svg";